/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
	class BackToTop extends HTMLElement {
	  constructor() {
			super();
			this.pageHeight = window.innerHeight;
    		this.section = document.getElementsByClassName('email-signup')[0]; 
	  }

		connectedCallback() {
			this.addEventListener('click', this.onClick);
			window.addEventListener('scroll', this.checkVisible.bind(this));
		}

		checkVisible(event) {
			//window.requestAnimationFrame(() => {
				let y = window.scrollY;
				// Change to the ID of the section containing the button
				if (!this.section) return; // Check if the section exists
		
				let sectionRect = this.section.getBoundingClientRect();
				let buttonRect = this.getBoundingClientRect();
				//console.log(y, this.pageHeight);
				if (y > this.pageHeight) {
					this.classList.add('back-to-top--active');
					if (buttonRect.top >= sectionRect.top) {
						this.classList.add('neutral');
					} else {
						this.classList.remove('neutral');
					}
					let emailSignupTop = this.section.offsetTop - this.pageHeight;
					if (y < emailSignupTop) {
						this.classList.add('back-to-top--active');
						this.classList.remove('neutral');
					}
				} else {
					this.classList.remove('back-to-top--active');
					this.classList.remove('neutral');
				}			
			//});
		}

		onClick() {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth"
			});
	  }
	}
	customElements.define('back-to-top', BackToTop);
}
